<template>
    <section id="result-search-page">
        <div :class="containerClasses">
            <div class="row">
                <div class="search-result-top">
                    <div class="top">
                        <div class="left">
                            <h2>
                                My Garage
                            </h2>
                        </div>
                    </div>
                    <div class="bottom space-between">
                        <div class="left">
                            <span class="showing">
                                <strong>Showing</strong>
                                <span>{{ from }}</span>-<span>{{ to }}</span> of <span>{{ total }}</span>
                                results
                            </span>
                            <div class="view-type-selection">
                                <label for="view-grid" :class="viewType === 'grid' ? 'active' : ''">
                                    <input id="view-grid" type="radio" value="grid" v-model="viewType" />
                                    <icon icon=" fa-lg fa-th"></icon>
                                </label>
                                <label for="view-list" :class="viewType === 'list' ? 'active' : ''">
                                    <input id="view-list" type="radio" value="list" v-model="viewType" />
                                    <icon icon=" fa-lg fa-list"></icon>
                                </label>
                            </div>
                            <select v-if="viewType === 'grid'" class="per-row" v-model="perRow">
                                <option v-for="option in vehicles_in_row_options" :value="option.value">
                                    {{ option.text }}
                                </option>
                            </select>
                            <div class="div select-all" v-if="!$userIsRole('dealer')">
                                <user-selector
                                    v-model="userFilter"
                                    @change="onChange"
                                    :include-me="false"
                                    :filter-by-shared-sales-reps="true"
                                >
                                </user-selector>
                            </div>
                            <div class="div select-all" v-if="userHasPrivilege('can_see_company_stock')">
                                <b-form-checkbox @change="onChange" v-model="includeCompanyStock">
                                    Include Company Stock
                                </b-form-checkbox>
                            </div>
                            <div class="select-all">
                                <el-select v-model="makeFilter" @change="onMakeChange">
                                    <el-option :value="null" label="Filter by make"></el-option>
                                    <el-option
                                        v-for="item in makes"
                                        :key="item.make"
                                        :label="item.make"
                                        :value="item.make">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="select-all" v-if="makeFilter" >
                                <el-select v-model="modelFilter" :loading="modelsLoading" @change="onChange" class="mr-2">
                                    <el-option :value="null" label="Filter by model"></el-option>
                                    <el-option
                                        v-for="item in models"
                                        :key="item.model"
                                        :label="item.model"
                                        :value="item.model">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="select-all">
                                <input id="filter-stockid" type="text" v-model="search" placeholder="Stock ID / Chassis" title="Search multiple by separating by comma or space" @keyup="onChange" />
                            </div>
                            <div class="pull-right">
                                <a v-if="$userIsAdmin()" class="btn" @click.prevent="openSendEmailModalFunc()">Send Email</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="bid-history" class="container-table">
                    <div v-if="viewType === 'list'">
                        <b-table
                                class="list-table"
                                responsive
                                :sort-by.sync="sort_by"
                                :sort-desc.sync="sort_desc"
                                @sort-changed="onChange"
                                :fields="fields"
                                :items="vehicle_stocks"
                                :no-local-sorting="true"
                                show-empty
                        >
                            <template v-slot:empty="scope">
                                No data is available...
                            </template>
                            <template v-slot:cell(vehicle)="data">
                                <a :href="getVehicleLink(data.item.id)" @click.prevent="goToCar(data.item)">
                                    <img :src="data.item.front_image_url" alt="Front"
                                         v-if="data.item.front_image_url" height="50">
                                </a>
                            </template>
                            <template v-slot:cell(mileage)="data">
                                {{ numberWithCommas(data.item.mileage) }}
                            </template>
                            <template v-slot:cell(images)="data">
                                <div class="image-hover-container">
                                    <vehicle-hover-images :vehicle="data.item" :letters_only="true"></vehicle-hover-images>
                                </div>
                            </template>
                            <template v-slot:cell(sold_price)="data">
                                <template v-if="data.item.sold_price">
                                    <template v-if="countries[data.item.currency]">
                                        {{countries[data.item.currency].sign}}
                                    </template>
                                    {{ numberWithCommas(data.item.sold_price) }}
                                    {{ data.item.currency }}
                                </template>
                            </template>
                            <template v-slot:cell(stock_id)="data">
                                <template v-if="data.item.stock_id">
                                    {{data.item.stock_id}}
                                </template>
                                <template v-else-if="data.item.sold && data.item.sold.heiwa_stock_id">
                                    {{data.item.sold.heiwa_stock_id}}
                                </template>
                                <template v-else>
                                    {{data.item.green_tree_sync_id}}
                                </template>
                            </template>
                            <template v-slot:row-details="row">
                                <div class="details">

                                    <div class="all-bid" v-if="row.item.messages">
                                        <div v-for="(msg ,index) in row.item.messages">
                                            <div class="bid history-bid" :class="selectedMessage && selectedMessage.id === msg.id ? 'selected' : ''" @click="selectMessage(msg)">
                                                <div class="cross item">
                                                    <button @click="deleteMessage(msg.id, row.item.id)"><img src="../../../images/cross.svg" alt="Collapse"></button>
                                                </div>
                                                <div class="date item">
                                                    {{ getDate(msg.created_at) }}
                                                </div>
                                                <div class="hour item">
                                                    {{ getTime(msg.created_at) }}
                                                </div>
                                                <div class="name item">
                                                    {{ msg.user.name }}
                                                </div>
                                                <div class="note item">
                                                    <strong v-if="msg.rep_only">staff: </strong>
                                                    {{msg.message}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="history-buttons">
                                        <a class="link add-message" @click="openMessageModal(row.item, false)">
                                            Add Message
                                        </a>
                                        <a class="link staff-message" @click="openMessageModal(row.item, true)" v-if="row.item.sbl_id && $userIsAdmin()">
                                            Staff Message
                                        </a>
                                    </div>
                                </div>
                            </template>
                            <template v-slot:cell(actions)="data">
                                <a v-if="$userCan('edit_stock')" :href="$laravelRoute('vehicle-stock.edit', data.item.id)">Edit |</a>
                                <a v-if="$userCan('delete_stock')" href="#!" @click.prevent="deleteVehicleStock(data.item.id)">Delete |</a>
                                <a :href="getVehicleLink(data.item.id)" @click.prevent="goToCar(data.item)">View</a>
                            </template>
                        </b-table>
                    </div>
                    <div class="container-results" id="container-results" v-else>
                        <div v-if="vehicle_stocks.length === 0">
                            No vehicles
                        </div>
                        <div  class="single-result-search"
                              v-for="vehicle of vehicle_stocks"
                        >
                            <div class="container-single-result-search">
                                <div class="stockid">
                                    <span class="checkbox" v-if="$userIsAdmin()">
                                        <input type="checkbox" :id="'select-vehicle-'+vehicle.id"
                                               v-model="selected_ids" :value="vehicle.id"/>

                                        <label :for="'select-vehicle-'+vehicle.id" @click.stop.prevent="selectVehicle(vehicle, $event)"></label>
                                    </span>
                                    <template v-if="vehicle.sold && vehicle.sold.heiwa_stock_id && !vehicle.stock_id">
                                        {{vehicle.sold.heiwa_stock_id}}
                                    </template>
                                    <template v-else>
                                        {{vehicle.stock_id}}
                                    </template>
                                </div>
                                <div class="image-hover-container">
                                    <vehicle-hover-images :vehicle="vehicle"></vehicle-hover-images>
                                </div>
                                <div class="image-vehicle">
                                    <a :href="getVehicleLink(vehicle.id)" @click.prevent="goToCar(vehicle)">
                                        <img :src="vehicle.front_image_url" alt="Front"
                                             v-if="vehicle.front_image_url">
                                    </a>
                                </div>
                                <div class="model">
                                    {{ vehicle.year }} {{ vehicle.make }}<br>
                                    <span v-html="vehicle.model"></span> /
                                    <span v-html="vehicle.grade"></span>
                                </div>
                                <div class="info">
                                    <strong>Auction grade:</strong>
                                    <span class="rating">{{ vehicle.rating }}</span>
                                    <br>
                                    <strong>KM:</strong>
                                    <span class="mileage">{{ numberWithCommas(vehicle.mileage) }}km</span>
                                </div>
                                <div class="details">
                                    {{vehicle.transmission}} / {{convertEquipment(vehicle.equipment)}}
                                </div>
                                <div class="notes" v-if="vehicle.sales_note">
                                    <div v-html="vehicle.sales_note"></div>
                                </div>

                                <div class="view-more">
                                    <a class="link arrow" :href="getVehicleLink(vehicle.id)" @click.prevent="goToCar(vehicle)">
                                        View more
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div  class="single-result-search none" v-for="vehicle of [1,2,3,4,5,6,7,8]"></div>
                    </div>
                </div>
                <div class="bottom-container-result d-flex justify-content-end flex-wrap">
                    <div class="d-flex justify-content-end">

                        <a :href="csvLink" target="_blank">CSV</a>
                        <b-pagination
                                v-if="total > 0"
                                :total-rows="total"
                                v-model="current_page"
                                :per-page="per_page"
                        ></b-pagination>
                    </div>
                </div>
            </div>
        </div>
        <vehicle-stock-message ref="vehicleStockMessage" @changed="onVehicleStockMessagesAdd"/>
        <vehicle-stock-send-email :vehicle-ids="selected_ids" v-model="openSendEmailModal"/>
    </section>
</template>
<script>
    import { mapState, mapActions } from 'vuex'
    import {addPageUrlParam, addToUrlQuery, numberWithCommas, objLookup, objToUrl} from '../../util/common'
    import vehicleStockMessage from '../VehicleStock/VehicleStockMessage'
    import UserSelector from '../Common/UserSelector'
    import VehicleHoverImages from '../Common/VehicleHoverImages'
    import VehicleStockSendEmail from "../VehicleStock/VehicleStockSendEmail";
    export default {
        props: [
            'filterByUserRegion'
        ],
        components: {
            'vehicle-stock-message': vehicleStockMessage,
            'user-selector': UserSelector,
            VehicleHoverImages,
            VehicleStockSendEmail
        },
        created(){
            this.fillSearchFields()
            this.getData();
            this.$store.dispatch('stock_nextprev/checkStack');
            this.$store.dispatch('stock_nextprev/checkListReturn', this.$route.query.state_key || null)
            this.$store.dispatch('vehicleStock/getMakes');
        },
        data() {
            return {
                sort_by: 'sold_date',
                sort_desc: true,
                openSendEmailModal: false,
                makeFilter: null,
                includeCompanyStock: false,
                modelFilter: null,
                selected_search: null,
                userFilter: null,
                selectedMessage: null,
                modelsLoading: false,
                search: null,
                viewType: 'list',
                perRow: 5,
                users: [],
                vehicles_in_row_options: [
                    {value: 0, text: 'FULL WIDTH'},
                    {value: 5, text: '5 per row'},
                    {value: 6, text: '6 per row'},
                ],
                countries: window.countries,
                selected_ids: [],
                fields: [
                    {label: 'Purchased', key: 'sold_date',sortable: true, formatter: 'dateFormat'},
                    {label: 'Vehicle', key: 'vehicle'},
                    {label: 'Images', key: 'images'},
                    {label: 'Stock No', key: 'stock_id', sortable: true},
                    {label: 'Make', key: 'make',sortable: true},
                    {label: 'Model', key: 'model', sortable: true},
                    {label: 'Year', key: 'year', sortable: true},
                    {label: 'Mileage', key: 'mileage', sortable: true},
                    {label: 'Colour', key: 'color', sortable: true},
                    {label: 'Chassis', key: 'chassis', sortable: true},
                    {label: 'Reference', key: 'reference',sortable: true},
                    {label: 'Price', key: 'sold_price',sortable: true},
                    {label: 'ETA', key: 'estimated_arrival_date',sortable: true},
                    {label: 'ETD', key: 'estimated_departure_date',sortable: true},
                    {label: 'Auc Date', key: 'auction_date',sortable: true, formatter: 'dateFormat'},
                    {label: 'Actions', key: 'actions'},
                ],
            }
        },
        computed: {
            ...mapState({
                vehicleStockAll: state => state.vehicleStock.all,
                per_page: state => state.vehicleStock.per_page,
                from: state => state.vehicleStock.from,
                to: state => state.vehicleStock.to,
                last_page: state => state.vehicleStock.last_page,
                total: state => state.vehicleStock.total,
                makes: state => state.vehicleStock.makes,
                models: state => state.vehicleStock.models,
            }),
            vehicle_stocks(){
                return this.vehicleStockAll.map(item => {
                    item._showDetails = true
                    return item
                })
            },
            current_page: {
                get(){
                    return this.$store.getters['vehicleStock/currentPage'];
                },
                set(value){
                    this.$store.commit('vehicleStock/setCurrentPage', value)
                    addPageUrlParam(value, this.$router)
                }
            },
            csvLink(){
                let url_path = this.$route.path
                let query = this.$route.query
                query.format = 'csv'
                let url = url_path + '?' + objToUrl(query)
                return url
            },

            containerClasses() {
                let classes = ['container'];
                if (this.perRow === 0 || this.viewType === 'list') {
                    classes.push('full-width');
                } else if (this.perRow === 5) {
                    classes.push('per-5');
                } else if (this.perRow === 6) {
                    classes.push('per-6');
                }
                return classes.join(' ');
            },
            pageParam () {
                return this.$route.query.page
            }
        },
        methods: {
            ...mapActions({
                addToNextPrevStack: 'stock_nextprev/addToStack',
            }),
            dateFormat(value, key, row){
                return value ? window.moment(value).format(this.defaultMomentDateFormat()) : ''
            },

            async selectVehicle(vehicle, e) {
                let selected = this.selected_ids.indexOf(vehicle.id);
                if (selected !== -1) {
                    this.selected_ids.splice(selected, 1);
                } else {
                    this.selected_ids.push(vehicle.id);
                }
                this.$emit('selectVehicle', vehicle, this.selected_ids, e)
            },

            openSendEmailModalFunc(){
                if (this.selected_ids.length) {
                    this.openSendEmailModal = true
                } else {
                    this.$message.error('Please select at least 1 vehicle to send an email.');
                }
            },
            selectMessage(msg) {
                if (this.selectedMessage && this.selectedMessage.id === msg.id) {
                    this.selectedMessage = null
                } else {
                    this.selectedMessage = msg
                }
            },
            async onMakeChange(){
                this.modelFilter = null
                this.replaceState()
                this.getData(1)
                await this.loadModels()
            },
            async loadModels(){
                this.modelsLoading = true;
                await this.$store.dispatch('vehicleStock/getModels', this.makeFilter);
                this.modelsLoading = false;
            },
            fillSearchFields(){
                if (this.$route.query.user_id) {
                    this.userFilter = parseInt(this.$route.query.user_id)
                }
                if(this.$route.query.make) {
                    this.makeFilter = this.$route.query.make
                    this.loadModels()
                }
                if(this.$route.query.model) {
                    this.modelFilter = this.$route.query.model
                }
                if(this.$route.query.search) {
                    this.search = this.$route.query.search
                }
                if (this.userHasPrivilege('can_see_company_stock') && this.$userIsDealer()) {
                    this.includeCompanyStock = true
                }
            },
            replaceState(){
                let args = {}
                if (this.makeFilter) {
                    args.make = this.makeFilter
                }
                if (this.modelFilter) {
                    args.model = this.modelFilter
                }
                if (this.search) {
                    args.search = this.search
                }
                if (this.userFilter) {
                    args.user_id = this.userFilter
                }
                let query = objToUrl(args)
                let url = this.$route.path
                if (query) {
                    url = `${url}?${query}`
                }
                this.$router.replace(url);

            },
            onChange(){
                this.replaceState()
                this.getData(1)
            },
            getData(page = 1){
                this.$nextTick(async () => {
                    let data = {
                        sort_by: this.sort_by,
                        sort_desc: this.sort_desc ? 1 : 0,
                        filter_by_user_region: this.filterByUserRegion,
                        filter_make: this.makeFilter,
                        filter_model: this.modelFilter,
                        include_company_stock: this.includeCompanyStock,
                        search: this.search,
                        page
                    }
                    if (this.userFilter) {
                        data.user_id = this.userFilter
                    }
                    if (this.$route.query.sold_date) {
                        data.filter_sold_date = this.$route.query.sold_date
                    }
                    const res = await this.$store.dispatch('vehicleStock/get', {endpoint: 'myGarage', args: data});
                    this.addToNextPrevStack({ids: this.$store.getters['vehicleStock/ids']});
                });
            },
            objLookup(obj, key){
                return objLookup(obj, key);
            },
            deleteVehicleStock (vehicleStockId) {
                this.$bvModal
                    .msgBoxConfirm('Are you sure you want to delete this vehicle?')
                    .then(value => {
                        if (value) {
                            this.$store.dispatch('vehicleStock/deleteVehicleStock', {
                                id: vehicleStockId,
                            }).then(vehicle_stocks => {
                                return this.getData(1)
                            });
                        }
                    })
            },
            displayAuctionHouse(orig_name) {
                let auctionName = '';
                if (orig_name) {
                    let name = orig_name.replace(/[^a-zA-Z]/, ' ').replace(/\s{2,}/, ' ');
                    // Auction name split in an array
                    if (name.indexOf(' ') !== -1) {
                        let arrayName = name.split(' ');
                        // Compose the auction name 2 chars for the first word and 3 chars for the second word.
                        auctionName = arrayName[0].slice(0, 2) + '-' + arrayName[1].slice(0, 3)
                    } else if (name.length > 2) {
                        auctionName = name.slice(0, 2);
                    }
                }
                return auctionName;
            },
            getVehicleLink(id) {
                let url = this.$laravelRoute('vehicle-stock.show', id, false);
                if (window.history && window.history.state && window.history.state.key) {
                    url = addToUrlQuery(url, {state_key: window.history.state.key})
                }
                return url;
            },

            goToCar(vehicle) {
                let url = this.getVehicleLink(vehicle.id)
                this.$store.dispatch('stock_nextprev/leavingListPage')
                this.$router.push(url);
            },
            convertEquipment(item) {
                if(item) {
                    let html = item.replace(/ /g, ', ');
                    html = html.toUpperCase();
                    return html;
                }

                return '';
            },
            openMessageModal(vehicleStock, repOnly = false) {
                let msg = ''
                if (this.selectedMessage) {
                    msg = `Hi ${this.selectedMessage.user.first_name},  \n${this.selectedMessage.message}`
                }
                this.$refs.vehicleStockMessage.openModal(vehicleStock, repOnly, msg);
            },
            onVehicleStockMessagesAdd(vehicleStockId, message) {
                this.$store.commit('vehicleStock/addMessage', {id: vehicleStockId, message: message});
            },
            getDate(data) {
                return window.moment(data).format('YYYY/MM/DD')
            },
            getTime(data) {
                return window.moment(data).format('HH:mm')
            },
            numberWithCommas(val) {
                return numberWithCommas(val);
            },

            deleteMessage(message_id, stock_id){
                this.$bvModal
                    .msgBoxConfirm('Are you sure you want to delete this message?')
                    .then(value => {
                        if (value) {
                            this.messages = [];
                            this.$store.dispatch('vehicleStock/deleteVehicleStockMessage', {message_id, stock_id}).then(response => {
                                if (response) {
                                    //done..
                                } else {
                                    this.messages.push({type: 'danger', message: 'Could not delete message'});
                                }
                            }).catch(error => {
                                this.messages.push({type: 'danger', message: error.message});
                                this.errors = error.errors;
                            });
                        }
                    })
            },
        },
        watch: {
            pageParam (value) {
                if (value) {
                    this.$store.commit('auction_search/setCurrentPage', value)
                    this.getData(value)
                }
            }
        },
        mounted() {
            if (!this.$route.query.page) {
                addPageUrlParam(this.current_page, this.$router, true)
            }
        }
    }

</script>



// WEBPACK FOOTER //
// resources/js/components/MyGarage/MyGaragePage.vue